import { isDefined } from '@freelancer/utils';
import type { PoolModelApi } from 'api-typings/users/users';
import type { PoolModel } from './pools.model';
import { transformPoolSkill } from '../skills/skills.transformers';

export function transformPool(pool: PoolModelApi): PoolModel {
  if (
    !isDefined(pool.date_created) ||
    !isDefined(pool.is_insource_enabled) ||
    !isDefined(pool.is_currency_enabled) ||
    !isDefined(pool.seo_url)
  ) {
    throw new ReferenceError('Missing a required pool field');
  }

  return {
    id: pool.id,
    name: pool.name,
    displayName: pool.display_name,
    isTalentNetwork: pool.is_talent_network,
    isTestPool: pool.is_test_pool,
    dateCreated: pool.date_created * 1000,
    isInsourceEnabled: pool.is_insource_enabled,
    isCurrencyEnabled: pool.is_currency_enabled,
    seoUrl: pool.seo_url,
    skills: pool.jobs?.map(job => transformPoolSkill(job)),
  };
}
